<template>
  <v-container>
    <EntryForm v-bind:androidMobile="androidMobile"/>
    <v-img
      :src="packShot"
      contain
      class="packshot-footer"
    ></v-img>   
  </v-container>
</template>

<script>
import EntryForm from './forms/Entry'
export default {
  components: {
    EntryForm
  },
  props: ['isAndroid', 'isMobile'],
  data: () => ({
    packShot : {src:require('../assets/Packshots.png')},
    androidMobile: false
  }),
  mounted() {
    if(this.isAndroid && this.isMobile) {
      this.androidMobile = true;
    }
  }
};
</script>
